/* eslint-disable */

type Callback = (...args: any[]) => void;

class EventBus {
  private events: Record<string, Callback[]> = {};

  on(event: string, callback: Callback) {
    this.events[event] = this.events[event] || [];
    this.events[event].push(callback);
  }

  off(event: string, callback: Callback) {
    this.events[event] = this.events[event]?.filter(cb => cb !== callback);
  }

  emit(event: string, ...args: any[]) {
    this.events[event]?.forEach(callback => callback(...args));
  }
}

const eventBus = new EventBus();
export default eventBus;